'use client';

import { useFloating, useDismiss, useClick, useInteractions } from "../../../../external/@floating-ui/react/dist/floating-ui.react.js";
import { mergeRefs } from "../../../utils/props/mergeRefs.js";
import { autoUpdate } from "../../../../external/@floating-ui/dom/dist/floating-ui.dom.js";
import { offset, flip, shift } from "../../../../external/@floating-ui/react-dom/dist/floating-ui.react-dom.js";
function useFloatingUi({
  isOpen,
  setIsOpen,
  triggerRef
}) {
  const params = {
    placement: "bottom-start",
    open: isOpen,
    onOpenChange: setIsOpen,
    middleware: [offset(8), flip(), shift()],
    transform: true,
    whileElementsMounted: autoUpdate
  };
  const { refs, floatingStyles, context } = useFloating(params);
  const dismiss = useDismiss(context);
  const click = useClick(context);
  const { getReferenceProps, getFloatingProps } = useInteractions([
    click,
    dismiss
  ]);
  return {
    popoverProps: {
      wrapperRef: refs.setFloating,
      style: floatingStyles,
      ...getFloatingProps()
    },
    triggerProps: getReferenceProps({
      ref: mergeRefs(refs.setReference, triggerRef)
    })
  };
}
export {
  useFloatingUi
};
